import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'stripBasicMarkdown',
    standalone: true,
})
export class StripBasicMarkdownPipe implements PipeTransform {
    static transform(markdown: string) {
        if (!markdown) return '';

        return markdown
            .replace(/\*\*/g, '')
            .trim();
    }

    transform(markdown: string) {
        return StripBasicMarkdownPipe.transform(markdown);
    }
}

